
// 'a.b.etc'.split('.').reduce((o,i)=>(o||{})[i], obj)
const getString = code => {
    const item = code.split('.').reduce((o, i) => (o || {})[i], window.STRINGS);
    return item || code+'!';
}

export const lbl = txt => {
    const s = window.STRINGS['attributes'][txt] || txt;
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const trans = (code, params) => {
    const str = getString(code);
    if (!params) return str;
    return str.replaceAll(/:([a-z0-9]+)/ig, (_, p) => params[p] || '?');
}

export const ts2date = ts => {
    // 2021-10-19T11:37:32.000000Z
    const [dd, t] = ts.split('T');
    const [y, m, d] = dd.split('-');
    const [h, i] = t.split(':');
    return `${d}/${m}/${y} ${h}:${i}`;
}

export const nl2br = str => str.replace(/(?:\r\n|\r|\n)/g, '<br>');

// https://gist.github.com/codeguy/6684588
export const slugify = (text) => {
    return text
      .toString()                     // Cast to string
      .toLowerCase()                  // Convert the string to lowercase letters
      .normalize('NFD')               // The normalize() method returns the Unicode Normalization Form of a given string.
      .trim()                         // Remove whitespace from both sides of a string
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-');        // Replace multiple - with single -
}

export const read_cookie = (name) => {
    var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
    return (match ? decodeURIComponent(match[3]) : null);
}

export const by_id = a => a.reduce((prev, cur, i) => {
    prev[cur.id] = i;
    return prev;
}, {});

export const modalStyle = (state) => {
    if (state == 'open') {
        document.body.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = '10px';
    } else {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = null;
        document.body.style.paddingRight = null;
    }
};
